module.exports = __webpack_public_path__ + "img/woman-border-yellow.2f3272af.svg";